import React from 'react';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';


function BreandCardSlider({ sites }) {
    const themeMode = useSelector((state) => state.image.themeMode);


    const settings = {
        rows: 1,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    dots: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <div>
            {/* <!-- Start Clients Section --> */}
            <section className="br-client padding-tb-80">
                <h2 className="d-none">Lojas</h2>
                <div className="container">
                    <div className="row">
                        <div className="br-client-outer">
                            {/* <Slider {...settings} id="br-client-slider">
                                {
                                    clientdarkitem.map((data, index) => (
                                        <li key={index} className="br-client-item" data-animation="zoomIn">
                                            <div className="br-client-img"><a href={data.url} rel='noreferrer' target="_blank">
                                                {themeMode === "light" && <img alt="client" title="client" src={data.image} />}
                                            </a></div>
                                        </li>
                                    ))
                                }
                                
                            </Slider> */}
                            <h4 className="section-title">-- Deslize --</h4>
                            <Slider {...settings} id="br-client-slider">
                                {
                                    sites.map((data, index) => (
                                        <li key={index} className="br-client-item" data-animation="zoomIn">
                                            <div className="br-client-img"><a href={data.url} rel='noreferrer' target="_blank">
                                                <img alt={data.title} style={{ backgroundColor: themeMode === "light" ? "#e3e2de" : "#f2f0e9", border: '0px', width: "120px", height: "120px", borderRadius: "20%", objectFit: "contain", objectPosition: "center center" }} title={data.title} src={data.image} onError={(e) => {
                                                    e.target.src = 'https://parceirando.s3.amazonaws.com/media/landing/404.webp';
                                                }} />
                                            </a></div>
                                        </li>
                                    )) 
                                }
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- End Clients Section --> */}
        </div>
    )
}

export default BreandCardSlider
